/**
 * DDT Manager — Service Worker registration.
 * Registrazione best-effort: non blocca il rendering, non logga errori in dev.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Evitiamo il worker in dev (CRA dev-server proxy conflitta con intercept fetch)
  // In produzione (process.env.NODE_ENV === 'production') registriamo.
  // Nel preview Emergent, NODE_ENV è 'development' per CRA dev-server ma il backend
  // è a proxy — registriamo comunque e il SW ignora /api/ così non interferisce.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        // auto-aggiornamento: ricontrolla ogni ora se c'è un nuovo SW
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
          console.info('[SW] registration failed (ok in dev):', err?.message);
        }
      });
  });
}
